import(/* webpackMode: "eager" */ "/tmp/build-6a61356399f1da00140f2476/src/app/not-found.tsx");
